import './blank-page.scss'
// components
import Image from '../Image/image'
// assets
import blankImage from '../../../assets/images/blank.svg'

const BlankPage = () => {
	return (
		<main className='a-blank-page container'>
			<Image classes='a-blank-page__img' width='225' src={blankImage} alt='¡Ups! Algo ocurrió' />
			<h2>
				¡Ups! <br /> Algo ocurrió
			</h2>

			<p>
				Detectamos algo lo cual no permite continuar, por favor actualiza o vuelve a intentarlo más
				tarde.
			</p>
		</main>
	)
}

export default BlankPage
